module.exports = __webpack_public_path__ + "static/img/normal.da97b3eb.svg";